import { Button, cn } from '@heroui/react';

const anchorClassName =
  'pointer-events-none fixed left-0 top-0 h-px w-px min-h-px min-w-px overflow-hidden border-0 bg-transparent p-0 opacity-0 shadow-none ring-0';

/**
 * 与 [HeroUI AlertDialog / Modal Anatomy](https://heroui.com/docs/react/components/alert-dialog) 一致：
 * 根上的 `DialogTrigger` 会把首子节点交给 `PressResponder`；该子节点须为库内的 **`Button`**
 *（内置 `usePress` 等），仅用原生 `button` + `forwardRef` 仍会触发
 * “PressResponder was rendered without a pressable child”。
 *
 * 在完全受控（`isOpen` 由外部打开）时，用不可见的占位 `Button` 满足结构；不参与布局与点击。
 */
export function RacDialogTriggerAnchor() {
  return (
    <Button
      type="button"
      variant="ghost"
      isIconOnly
      aria-hidden
      className={cn(anchorClassName)}
    >
      {'\u200b'}
    </Button>
  );
}
